import React from "react";

const features = [
  {
    title: "22K Gold & Silver Mastery",
    desc: "We specialise in crafting exquisite 22K gold and fine silver jewellery  where purity meets artistry in every single ornament.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2l3 6 6 .9-4.5 4.4 1.1 6.4L12 16.8 6.4 19.7 7.5 13.3 3 8.9 9 8z" />
      </svg>
    ),
  },
  {
    title: "Rabari Ghat Specialists",
    desc: "Our signature expertise lies in traditional Rabari Ghat work  intricate detailing, cultural richness and craftsmanship passed down five generations.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2L3 7l9 5 9-5-9-5z" />
        <path d="M3 12l9 5 9-5" />
        <path d="M3 17l9 5 9-5" />
      </svg>
    ),
  },
  {
    title: "Bridal Heirlooms",
    desc: "From sacred mangal sutras to complete bridal sets, every piece is designed to be the treasured heirloom of tomorrow.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    ),
  },
  {
    title: "Nine Decades of Trust",
    desc: "Since 1933, our name has been a promise of heritage, precision and timeless elegance  trusted by generations of families.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    ),
  },
];

const timeline = [
  {
    year: "1933",
    name: "Late Shri Hargovan Das Soni",
    role: "The Founder",
    desc: "Laid the foundation of our legacy, built on unmatched craftsmanship and unwavering trust.",
  },
  {
    year: "1970",
    name: "Shri Mangaldas Soni",
    role: "The Visionary",
    desc: "Elevated the tradition of excellence, scaling the art to new heights of refinement.",
  },
  {
    year: "1998",
    name: "Shri Shiv Kumar Soni",
    role: "The Master",
    desc: "Further refined our signature craft, deepening our legacy with meticulous artistry.",
  },
  {
    year: "Today",
    name: "Viraj Soni",
    role: "5th Generation",
    desc: "Carries the heritage forward with a dynamic vision, blending tradition with contemporary elegance.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      className="relative py-16 sm:py-20 md:py-28 bg-gradient-to-b from-cream via-white to-gray-50"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.35em] text-gold-dark font-semibold mb-4">
            <span className="h-px w-8 bg-gold" />
            Our Story  Since 1933
            <span className="h-px w-8 bg-gold" />
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-maroon font-bold leading-tight">
            Nine Decades Woven in{" "}
            <span className="gold-gradient-text">Gold</span>
          </h2>
          <p className="mt-4 sm:mt-5 text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed">
            Since 1933, our name has stood as a symbol of{" "}
            <strong className="text-maroon">
              heritage, precision, and timeless elegance
            </strong>{" "}
            in fine jewellery. With over{" "}
            <strong className="text-maroon">nine decades of legacy</strong>, we
            create more than jewellerywe create enduring expressions of
            luxury, heritage, and trust.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-10 items-center mb-16 md:mb-20">
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border border-gold/30 bg-white p-6 sm:p-8">
              <div className="absolute top-0 right-0 w-40 h-40 bg-gold/10 rounded-full blur-2xl" />
              <h3 className="font-serif text-xl sm:text-2xl md:text-3xl text-maroon font-bold mb-4 relative">
                A Legacy Five Generations Deep
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4 relative">
                Established by{" "}
                <strong className="text-maroon">
                  Late Shri Hargovan Das Soni
                </strong>{" "}
                in 1933, the foundation of our legacy was built on unmatched
                craftsmanship and unwavering trust. This tradition of
                excellence was elevated by{" "}
                <strong className="text-maroon">Shri Mangaldas Soni</strong> in
                1970, further refined by{" "}
                <strong className="text-maroon">Shri Shiv Kumar</strong> in
                1998, and continues today under the dynamic vision of{" "}
                <strong className="text-maroon">Viraj Soni</strong>,
                representing the fifth generation of our esteemed lineage.
              </p>
              <p className="text-gray-700 leading-relaxed relative">
                We are masters in crafting{" "}
                <strong>exquisite 22K gold and silver jewellery</strong>, where
                purity meets artistry. Our signature expertise in traditional{" "}
                <strong>Rabari Ghat work</strong> reflects intricate detailing,
                cultural richness, and exceptional skill passed down through
                generations.
              </p>

              <div className="mt-6 flex flex-wrap gap-2 relative">
                <Badge text="Since 1933" />
                <Badge text="5 Generations" />
                <Badge text="BIS Hallmarked" />
              </div>
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-4 sm:gap-5">
            {features.map((f) => (
              <div
                key={f.title}
                className="group bg-white rounded-2xl p-5 sm:p-6 border border-gray-200 hover:border-gold shadow-sm hover:shadow-xl transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-maroon text-gold mb-4 group-hover:bg-gold group-hover:text-maroon transition-colors">
                  {f.icon}
                </div>
                <h4 className="font-serif text-lg sm:text-xl text-maroon font-bold mb-2">
                  {f.title}
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {f.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.35em] text-gold-dark font-semibold mb-3">
              <span className="h-px w-8 bg-gold" />
              The Lineage
              <span className="h-px w-8 bg-gold" />
            </span>
            <h3 className="font-serif text-2xl sm:text-3xl md:text-4xl text-maroon font-bold leading-tight">
              Five Generations, One{" "}
              <span className="gold-gradient-text">Legacy</span>
            </h3>
            <p className="mt-3 text-gray-600 text-sm sm:text-base max-w-xl mx-auto">
              Every generation has added a new chapter to our story  woven
              together in pure gold.
            </p>
          </div>

          <div className="relative">
            <div className="hidden lg:block absolute left-0 right-0 top-[72px] h-[2px] bg-gradient-to-r from-transparent via-gold to-transparent" />

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 lg:gap-4">
              {timeline.map((t, i) => (
                <div
                  key={t.year}
                  className="relative group"
                >
                  <div className="hidden lg:flex justify-center mb-6 relative">
                    <div className="relative z-10">
                      <div className="absolute inset-0 bg-gold/30 rounded-full blur-xl group-hover:bg-gold/50 transition-colors" />
                      <div className="relative w-14 h-14 rounded-full bg-white border-2 border-gold flex items-center justify-center shadow-lg">
                        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-maroon to-maroon-dark flex items-center justify-center">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#c9a227"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M12 2l3 6 6 .9-4.5 4.4 1.1 6.4L12 16.8 6.4 19.7 7.5 13.3 3 8.9 9 8z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="relative bg-white rounded-2xl p-5 sm:p-6 border border-gold/30 shadow-md hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 overflow-hidden h-full">
                    <div className="absolute top-0 right-0 w-24 h-24 bg-gold/10 rounded-full blur-2xl" />

                    <div className="lg:hidden flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 rounded-full bg-gradient-to-br from-maroon to-maroon-dark border-2 border-gold flex items-center justify-center flex-shrink-0">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#c9a227"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M12 2l3 6 6 .9-4.5 4.4 1.1 6.4L12 16.8 6.4 19.7 7.5 13.3 3 8.9 9 8z" />
                        </svg>
                      </div>
                      <div className="text-[10px] uppercase tracking-[0.3em] text-gold-dark font-bold bg-gold/10 px-3 py-1 rounded-full">
                        {t.role}
                      </div>
                    </div>

                    <div className="hidden lg:block text-center mb-3">
                      <div className="inline-block text-[10px] uppercase tracking-[0.3em] text-gold-dark font-bold bg-gold/10 px-3 py-1 rounded-full">
                        {t.role}
                      </div>
                    </div>

                    <div className="relative font-serif text-3xl md:text-4xl text-maroon font-bold leading-tight mb-2 lg:text-center">
                      {t.year}
                    </div>

                    <div className="relative font-serif text-base text-maroon-dark font-semibold mb-3 lg:text-center">
                      {t.name}
                    </div>

                    <div className="hidden lg:block w-10 h-px bg-gold/40 mx-auto mb-3" />

                    <p className="relative text-gray-600 text-sm leading-relaxed lg:text-center">
                      {t.desc}
                    </p>
                  </div>

                  {i < timeline.length - 1 && (
                    <div className="hidden lg:flex absolute top-[65px] -right-4 z-20 items-center justify-center">
                      <div className="w-4 h-4 rounded-full bg-gold border-2 border-white shadow-md" />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          <div className="mt-20 md:mt-24 lg:mt-28 text-center relative z-10">
            <div className="inline-flex items-center gap-3 bg-white border border-gold/40 rounded-full px-5 py-2 shadow-sm">
              <span className="w-2 h-2 rounded-full bg-gold animate-pulse" />
              <span className="text-xs sm:text-sm text-maroon font-medium">
                Proudly continuing the legacy  since 1933
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Badge({ text }) {
  return (
    <span className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 rounded-full bg-maroon/5 text-maroon border border-maroon/20 text-[11px] sm:text-xs font-medium uppercase tracking-wider">
      <span className="w-1.5 h-1.5 rounded-full bg-gold" />
      {text}
    </span>
  );
}
